<template>
  <!-- 数据中台运行情况 -->
  <div class="h-full">
    <iframe class="w-full h-full" :src="`${currentEnv.VUE_APP_RUN_PAGE}`" frameborder="0"> </iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
    }
  },
}
</script>
